



























import RetailerPageContact from '@/models/retailerPageContact'
import { customer } from '@/store'
import Vue from 'vue'
import Component from "vue-class-component"

@Component
export default class ContactsModal extends Vue {

  // Геттерами, а не копией в created(): настройки витрины приезжают запросом, и
  // на первом заходе список контактов в этот момент ещё пустой
  get contacts(): Array<RetailerPageContact> {
    return (customer.retailerPage && customer.retailerPage.contacts) || []
  }

  get phones() {
    return this.contacts.filter(contact => contact.type == 'phone')
  }

  get links() {
    return this.contacts.filter(contact => contact.type == 'link')
  }

  get locations() {
    return this.contacts.filter(contact => contact.type == 'location')
  }
}
